import { render } from "./adopt-case.vue?vue&type=template&id=f06222be&scoped=true"
import script from "./adopt-case.vue?vue&type=script&lang=js"
export * from "./adopt-case.vue?vue&type=script&lang=js"

import "./adopt-case.vue?vue&type=style&index=0&id=f06222be&scoped=true&lang=css"

import exportComponent from "F:\\yiban\\WebProject\\yimeng-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f06222be"]])

export default __exports__